import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledPromoBanner = styled('div')`
  background-image: url(${({ metadata }) => metadata?.backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: ${({ metadata }) => metadata?.padding};
  gap: 16px;
  display: flex;
  border: 1px solid ${({ metadata }) => metadata?.borderColor};
  background-color: ${({ metadata }) => metadata?.backgroundColor};
  z-index: 1000;
  border-radius: 16px;
  box-sizing: border-box;
  bottom: 67px;
  justify-content: space-between;
  .close-icon-container {
    display: flex;
    align-items: center;
    .close-icon {
      cursor: pointer;
      color: #1e164ea3;
    }
  }

  .banner-image {
    padding: ${({ metadata }) => metadata?.paddingImage || '0px'};
  }

  .circular-progress {
    color: ${COLOR.darkBlue};
  }

  .banner-content {
    .banner-content-description {
      margin-top: ${({ metadata }) => metadata?.marginTopContent || '0px'};
    }
  }

  .content-button-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    justify-content: flex-end;
  }
`;
